import React, { FC, ChangeEvent } from 'react'
import { List, makeStyles, Box, Link } from 'transfix-ui/core'
import { brandColors, Switch } from 'transfix-ui'
import { useMarkAllReadMutation } from '../../graphql/MarkAllRead'
import { useNotificationsPolling } from '../../hooks/useNotificationsPolling'
import { TSingleNotification } from '../../types'
import NotificationListItem from '../NotificationListItem'

export interface INotificationListProps {
  notifications: TSingleNotification[]
  onMarkAsRead: (id: string) => void
}

const useNotificationListStyles = makeStyles(theme => ({
  top: {
    alignItems: 'center',
    backgroundColor: brandColors.white,
    borderBottom: `1px solid ${brandColors.coolGray4}`,
    color: brandColors.coolGray8,
    padding: '0px 15px',
  },
  title: {
    flexGrow: 1,
    fontSize: theme.typography.subtitle2.fontSize,
    fontWeight: theme.typography.fontWeightBold,
  },
  root: {
    left: 0,
    backgroundColor: brandColors.white,
    color: brandColors.coolGray8,
    paddingTop: 0,
    paddingBottom: 0,
  },
}))

/**
 * List wrapper for `<NotificationListItem />`
 */
const NotificationList: FC<INotificationListProps> = ({
  notifications = [],
  onMarkAsRead: onMarkAsReadProp,
}) => {
  const classes = useNotificationListStyles()
  const { notificationsMuted, setNotificationsMuted } = useNotificationsPolling()
  const onMuteNotifications = ({ target: { checked } }: ChangeEvent<HTMLInputElement>): void => {
    setNotificationsMuted(checked ? '1' : '0')
  }

  const [markAllReadMutation] = useMarkAllReadMutation()

  const onMarkAllRead = (): void => {
    markAllReadMutation()
  }

  return (
    <>
      <Box display='flex' className={classes.top}>
        <Box className={classes.title}>Notifications</Box>
        <Box display='flex' alignItems='center'>
          <Box>
            <Switch
              label='Mute notifications'
              value={notificationsMuted}
              checked={notificationsMuted === '1'}
              onChange={onMuteNotifications}
            />
          </Box>
          <Box>
            <Link onClick={onMarkAllRead}>Mark all read</Link>
          </Box>
        </Box>
      </Box>
      <List className={classes.root}>
        {notifications.map(notification => {
          const { id } = notification || {}
          return (
            <NotificationListItem
              notification={notification}
              key={`notification-item-${id}`}
              onMarkAsRead={onMarkAsReadProp}
            />
          )
        })}
      </List>
    </>
  )
}

export default NotificationList
